import React, { useState } from "react";

const GOOGLE_FORM_ACTION_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScT2_qMhmfxINfvup2ey-U7A4Y0yygZTkLcvf7s_C7Cic933g/formResponse';
const RATING_FIELD = 'entry.2125740814';
const COMMENT_FIELD = 'entry.1473768020';
const EMAIL_FIELD = 'entry.1592077490';

export default function FeedbackFloater({ hide = false }) {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackRating, setFeedbackRating] = useState(0);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [expanded, setExpanded] = useState(true);

  const handleFeedbackSubmit = (e) => {
    e.preventDefault();
    if (window.gtag) {
      window.gtag('event', 'feedback_submit', {
        event_category: 'engagement',
        event_label: 'Feedback Submitted'
      });
    }
    const formData = new FormData();
    formData.append(RATING_FIELD, feedbackRating);
    if (feedbackText.trim()) formData.append(COMMENT_FIELD, feedbackText.trim());
    if (userEmail.trim()) formData.append(EMAIL_FIELD, userEmail.trim());

    fetch(GOOGLE_FORM_ACTION_URL, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
    });

    setFeedbackSubmitted(true);
    setTimeout(() => {
      setShowFeedbackModal(false);
      setFeedbackSubmitted(false);
      setFeedbackRating(0);
      setFeedbackText('');
      setUserEmail('');
    }, 2000);
  };

  const paypalDonateUrl = "https://www.paypal.com/donate/?hosted_button_id=FGPNV7YTRPPVE";
  const handleDonateClick = () => {
    if (window.gtag) {
      window.gtag('event', 'donate_click', {
        event_category: 'engagement',
        event_label: 'Donate Floater Button'
      });
    }
    window.open(paypalDonateUrl, '_blank');
  };

  if (hide) return null;

  return (
    <>
      {/* Collapse/Expand Floater Icon */}
      <button
        onClick={() => setExpanded((e) => !e)}
        className="fixed bottom-6 right-28 z-50 bg-gray-600 text-white rounded-full shadow-lg p-3 hover:bg-gray-700 transition-all duration-300 flex items-center justify-center"
        aria-label={expanded ? "Hide floating buttons" : "Show floating buttons"}
        style={{position: 'fixed', bottom: 24, right: 24, zIndex: 9999}}
      >
        {expanded ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
        )}
      </button>
      {/* Donate Floater Button..*/}
      {expanded && (
        <button
          className="fixed bottom-36 right-6 z-40 bg-gradient-to-r from-yellow-400 to-orange-500 text-white rounded-full shadow-lg px-6 py-3 font-semibold text-lg hover:from-yellow-500 hover:to-orange-600 transition-all duration-300 flex items-center gap-2 animate-fade-in"
          style={{position: 'fixed', bottom: 144, right: 24, zIndex: 9999}}
          onClick={handleDonateClick}
          aria-label="Donate with PayPal"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
          <span className="hidden sm:inline">Donate</span>
        </button>
      )}
      {/* Feedback Floater Button */}
      {expanded && (
        <button
          className="fixed bottom-20 right-6 z-40 bg-blue-600 text-white rounded-full shadow-lg px-6 py-3 font-semibold text-lg hover:bg-blue-700 transition-all duration-300 flex items-center gap-2 animate-fade-in"
          style={{position: 'fixed', bottom: 80, right: 24, zIndex: 9999}}
          onClick={() => setShowFeedbackModal(true)}
          aria-label="Give Feedback"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M7 8h10M7 12h4m-2 8a9 9 0 110-18 9 9 0 010 18z" /></svg>
          <span className="hidden sm:inline">Feedback</span>
        </button>
      )}
      {showFeedbackModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md relative animate-fade-in">
            <button
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl font-bold"
              onClick={() => setShowFeedbackModal(false)}
              aria-label="Close Feedback"
            >
              ×
            </button>
            {feedbackSubmitted ? (
              <div className="text-center py-8">
                <div className="text-3xl mb-2">🎉</div>
                <div className="text-lg font-semibold text-blue-700">Thank you for your feedback!</div>
              </div>
            ) : (
              <form onSubmit={handleFeedbackSubmit} className="flex flex-col gap-4">
                <h2 className="text-xl font-bold text-blue-800 mb-2 text-center">We value your feedback</h2>
                <div className="flex items-center justify-center gap-2">
                  {[1,2,3,4,5].map(star => (
                    <button
                      type="button"
                      key={star}
                      onClick={() => setFeedbackRating(star)}
                      className={star <= feedbackRating ? "text-yellow-400" : "text-gray-300"}
                      aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
                    >
                      <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.454a1 1 0 00-1.175 0l-3.38 2.454c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" /></svg>
                    </button>
                  ))}
                </div>
                <textarea
                  className="border border-blue-200 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-300 transition min-h-[80px]"
                  placeholder="Your comments (optional)"
                  value={feedbackText}
                  onChange={e => setFeedbackText(e.target.value)}
                  maxLength={500}
                />
                <input
                  type="email"
                  className="border border-blue-200 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
                  placeholder="Your email (optional)"
                  value={userEmail}
                  onChange={e => setUserEmail(e.target.value)}
                  maxLength={100}
                />
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition mt-2"
                  disabled={feedbackRating === 0}
                >
                  Submit Feedback
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
} 